import { MessageSquare, TrendingUp, Receipt } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ChatWelcomeProps {
  onSuggestionClick?: (message: string) => void;
  isGuest?: boolean;
}

export function ChatWelcome({ onSuggestionClick, isGuest = false }: ChatWelcomeProps) {
  const suggestions = [
    {
      icon: Receipt,
      title: "Track my receipts",
      message: "Help me organize and track all my receipts for tax season"
    },
    {
      icon: TrendingUp,
      title: "Find tax deductions",
      message: "What tax deductions am I eligible for based on my spending?"
    },
    {
      icon: MessageSquare,
      title: "Tax questions",
      message: "I have some questions about my taxes and how to save money"
    }
  ];

  return (
    <div className="flex-1 flex flex-col items-center justify-center px-4 py-8 md:py-12">
      <div className="w-full max-w-2xl space-y-8">
        <div className="text-center space-y-3 animate-fade-in">
          <h1 className="text-3xl md:text-4xl font-semibold text-foreground">
            {isGuest ? "Try Tax.GBT for Free! 🎉" : "What can I help you with?"}
          </h1>
          <p className="text-base md:text-lg text-muted-foreground">
            {isGuest 
              ? "Ask me anything about taxes - I'll help you find deductions and save money"
              : "Your AI tax assistant is ready to help you save money"
            }
          </p>
        </div>

        {onSuggestionClick && (
          <div className="grid gap-3 md:gap-4">
            {suggestions.map((suggestion, index) => (
              <Button
                key={index}
                variant="outline"
                className="h-auto p-4 md:p-5 justify-start text-left hover:bg-muted/50 transition-all duration-300 hover:scale-[1.02] group animate-slide-up"
                style={{ animationDelay: `${index * 100}ms`, animationFillMode: 'backwards' }}
                onClick={() => onSuggestionClick(suggestion.message)}
              >
                <suggestion.icon className="w-5 h-5 mr-3 text-muted-foreground group-hover:text-foreground transition-colors flex-shrink-0" />
                <span className="text-sm md:text-base">{suggestion.title}</span>
              </Button>
            ))}
          </div>
        )}

        {!onSuggestionClick && isGuest && (
          <div className="grid gap-3 md:gap-4">
            {suggestions.map((suggestion, index) => (
              <div
                key={index}
                className="h-auto p-4 md:p-5 flex items-center text-left border rounded-lg bg-muted/30 animate-slide-up"
                style={{ animationDelay: `${index * 100}ms`, animationFillMode: 'backwards' }}
              >
                <suggestion.icon className="w-5 h-5 mr-3 text-muted-foreground flex-shrink-0" />
                <span className="text-sm md:text-base text-muted-foreground">{suggestion.title}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
